import Scene = Phaser.Scene;
import {lazyInject} from "@/container";
import {TYPES} from "@/types";
import {SceneService} from "@/services/scene-service";
import SceneUtils from "@/utils/scene-utils";
import {LoadUtils, LoaderState} from "@/utils/load-utils";
import PlayerStore from "@/store/player";
import {Keys} from "@/constants/key";

export default class LoadScene extends Scene {

    @lazyInject(TYPES.SceneService)
    private sceneService!: SceneService;

    private canvas!: HTMLCanvasElement;
    private loaderState!: LoaderState;

    constructor() {
        super({ key: 'LoadScene' });
    }

    public preload(): void {

        this.canvas = this.sys.game.canvas;

        this.loaderState = new LoaderState();
        LoadUtils.showLoadingScreen(this, this.canvas, this.loaderState);
        SceneUtils.setCurrentScene(this);

        let player = PlayerStore.getPlayer();
        let stair = !!player ? player.stair : 1;

        LoadUtils.loadCampaignDepending(this, player);

        if (player && !this.textures.exists(Keys.ATLAS_CREATURES_BATTLE_1)) {
            this.load.atlas(Keys.ATLAS_CREATURES_BATTLE_1, 'assets/creatures/creatures-battle-1-f.png', 'assets/creatures/creatures-battle-1-f.json');
        }
    }

    public create(): void {
        LoadUtils.goToNewSceneAfterLoad(this, this.sceneService);
    }

    update(time: number, delta: number) {
        this.loaderState.update(time, delta);
    }

}
